/** Shown next to note submission and alias fields. Keep in sync with the server rule in src/utils/noteResponseFilter.ts (publicAttribution). */
export const ATTRIBUTION_NOTICE =
  'Your first and last name are never shown. Notes are posted as Anonymous unless you set an alias.';

